import { render, staticRenderFns } from "./FormCreateBufferAccount.vue?vue&type=template&id=3a38534e&"
import script from "./FormCreateBufferAccount.vue?vue&type=script&lang=ts&"
export * from "./FormCreateBufferAccount.vue?vue&type=script&lang=ts&"
import style0 from "./FormCreateBufferAccount.vue?vue&type=style&index=0&id=3a38534e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports